import React from "react";

import { Shelf, Stack, useResponsive, ShelfProps, StackProps } from "capitalrx-components-2.0/lib/layout";

type CommonProps = {
  /** Set to true if you prefer the tablet setting to be narrow. Defaults to false. */
  isTabletNarrow?: boolean;
  /** Set to true if you prefer the the shelf contents to wrap to the next line. Defaults to false. */
  wrapRows?: boolean;
  children: React.ReactNode;
} & (ShelfProps | StackProps);

export const StackOrShelf = (props: CommonProps): JSX.Element => {
  const { children, isTabletNarrow = false, wrapRows = false } = props;
  const { isNarrow } = useResponsive({
    isNarrow: {
      desktop: false,
      tablet: isTabletNarrow,
      mobile: true,
    },
  });

  if (isNarrow) {
    return <Stack {...(props as StackProps)}>{children}</Stack>;
  } else {
    return (
      <Shelf {...(props as ShelfProps)} style={wrapRows ? { flexWrap: "wrap", justifyContent: "flex-start" } : {}}>
        {children}
      </Shelf>
    );
  }
};
